export default {
	tableHeaders: {
		database: {
			name: 'Название',
			shortName: 'Короткое название',
			alias: 'Алиас',
			baseType: 'Тип базы',
			comment: 'Комментарий',
			server: 'Сервер'
		},
		app: {
			name: 'Название',
			alias: 'Алиас',
			apiType: 'Тип приложения',
			path: 'Путь',
			server: 'Сервер',
			isWebApp: 'web?',
			yes: 'да',
			no: 'нет'
		},
		server: {
			name: 'Название',
			serverType: 'Тип сервера',
			httpPath: 'Путь http',
			host: 'Хост',
			path: 'Путь',
			isTiny: 'Tiny'
		},
		user: {
			login: 'Логин',
			password: 'Пароль',
			fullName: 'ФИО',
			datePassword: 'Дата пароля',
			dateEnd: 'Дата создания',
			dateBegin: 'Дата окончания',
			role: 'Роль',
			status: 'Статус',
			statusDisabled: 'отключен',
			statusEnabled: 'включен'
		},
		role: {
			id: 'ID',
			name: 'Название',
			type: 'Тип роли'
		},
		appParam: {
			id: 'ID',
			name: 'Название'
		},
		upgrades: {
			idVersion: "ID версии",
			datecurr: "Дата установки"
		},
		process: {
			app: 'Приложение',
			db: 'База данных',
			lstart: 'Старт задачи',
			etime: 'Время работы',
			pcpu: 'Загрузка CPU, %',
			ip: 'IP адрес',
			user: 'Пользователь'
		},
		service: {
			s: 'Сервис',
			p: 'Параметр',
			st: 'Статус',
			dst: 'Доп. статус'
		},
		statusTask: {
			id: '№',
			pidTask: 'pid',
			nameTask: 'Задача',
			paramsTask: 'Параметры',
			nameServer: 'Сервер',
			qDateBegin: 'Запущена',
			qDateEnd: 'Завершена',
			nameUser: 'Кем',
			comment: 'Примечание'
		},
		task: {
			id: 'ID',
			caption: 'Название',
			path: 'Путь',
			isPacketable: 'В пакете',
			idTypeTask: 'Тип задачи',
			comment: 'Комментарий'
		}
	}
};
